export interface LimitMeasurementDTO {
  code: LimitMeasurementCodesEnum;
  description: string;
  detailedDescription: object;
  enabled: boolean;
  createdOn: string;
  updatedOn: string;
}

export enum LimitMeasurementCodesEnum {
  VOLUME = 'VOLUME',
  AMOUNT = 'AMOUNT',
  NUMBER_REFUELS = 'NUMBER_REFUELS',
}
